import React, { useState } from 'react'; 
import { Outlet, useNavigate } from 'react-router-dom';
import UserNavbar from './UserNavbar';
import { FaBook, FaCalendarAlt, FaChevronRight, FaBars } from 'react-icons/fa';
import SubPageHeader from '../common/SubPageHeader'; 
import SubPageFooter from '../common/SubPageFooter';

const UserLayout = ({ userData }) => {
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    // const isMobile = window.innerWidth < 768;
    // useEffect(() => {
    //     const handleResize = () => {
    //         setIsMobile(window.innerWidth < 768);
    //     };

    //     window.addEventListener('resize', handleResize);

    //     return () => {
    //         window.removeEventListener('resize', handleResize);
    //     };
    // }, []);

    return (
        <div className="min-h-screen  flex flex-col">
            
            {/* १. navbar */}
            <UserNavbar
                userInfo={userData}
                onMenuClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            />
            {isMobileMenuOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-[9998] md:hidden"
                    onClick={() => setIsMobileMenuOpen(false)}
                />
            )}

            <div className="flex flex-1 relative pt-[64px]">

                
                {/* २. sidebar - top-[64px]  */}
                <div
                    className={`
                        fixed
                        left-0
                        top-[64px]
                        bottom-0
                        bg-[#212121]
                        text-white
                        z-[9999]
                        transition-all
                        duration-300

                        ${
                            isMobileMenuOpen
                                ? 'translate-x-0'
                                : '-translate-x-full'
                        }

                        md:translate-x-0

                        ${isHovered ? 'md:w-64' : 'md:w-20'}

                        w-64
                        flex
                        flex-col
                    `}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <nav className="mt-4 flex-1 px-2 space-y-1 overflow-y-auto">
                        <button onClick={() => {
                                    navigate('/TGSH/user/dashboard');
                                    setIsMobileMenuOpen(false);
                                }} className="w-full flex items-center gap-3 p-3 rounded-md bg-white/10 hover:bg-white/20 transition-all border-none cursor-pointer text-white">
                                                            <FaBook className="text-lg flex-shrink-0" />
                            {(isHovered || isMobileMenuOpen) && (
                                <span className="font-bold text-[12px] tracking-wider uppercase">
                                    MY COURSES
                                </span>
                            )}
                        </button>

                        <button onClick={() => {
                                    navigate('/TGSH/user/upcoming-events');
                                    setIsMobileMenuOpen(false);
                                }} className="w-full flex items-center gap-3 p-3 rounded-md hover:bg-white/10 transition-all border-none cursor-pointer text-white">
                            <FaCalendarAlt className="text-lg flex-shrink-0 text-gray-400" />
                            {(isHovered || isMobileMenuOpen) && (
                                <span className="font-bold text-[12px] tracking-wider uppercase">
                                    UPCOMING EVENTS
                                </span>
                            )}
                        </button>
                        {/* <button
                            className="md:hidden text-white text-xl mr-3"
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        >
                            <FaBars />
                        </button> */}
                    </nav>

                    <div className="p-4 border-t border-white/10 flex items-center gap-3">
                        <FaChevronRight className={`text-xs transition-transform ${isHovered ? 'rotate-180' : ''}`} />
                        {(isHovered || isMobileMenuOpen) && (
                            <span className="text-[9px] opacity-50">
                                V 1.0.2
                            </span>
                        )}
                    </div>
                </div>

                {/* ३. main content area */}
                <div
                    className={`flex-1 flex flex-col transition-all duration-300 ${
                        isHovered
                            ? 'ml-0 md:ml-64'
                            : 'ml-0 md:ml-16'
                    }`}
                >
                    <SubPageHeader title="Welcome to TGSH" />
                    {/* <main
                    className="
                    flex-grow
                    min-h-screen
                    px-3
                    md:px-6
                    py-3
                    md:py-5
                    "
                    > */}
                    <main
                    className="
                        flex-grow
                        min-h-screen
                        px-2
                        sm:px-3
                        md:px-6
                        py-2
                        md:py-5
                        overflow-x-hidden
                    "
                    >
                        <div className="w-full mx-auto">
                            <Outlet />
                        </div>
                    </main>
                    <SubPageFooter />
                </div>
            </div>
        </div>
    );
};

export default UserLayout;